/**
 * The «placeholders» still in a document: each once, in reading order.
 *
 * The editor will not save a document that has one, because a guest would read
 * "«Operator legal name»" as the provider's name. So it must also say which are
 * left: the Terms template has eleven, on five lines of a long text. An
 * unclosed « runs to the end of its line, so a half-deleted marker is still
 * found; a » on its own is ordinary text.
 */
export function remainingPlaceholders(text: string): string[] {
  return [...new Set(text.match(/«[^«»\n]*»?/g) ?? [])];
}
